// extracted by mini-css-extract-plugin
export default {"strip":"Menu_strip__b8bDo","tittleDropdown":"Menu_tittleDropdown__iFUCv","button":"Menu_button__3L5RF","random":"Menu_random__TUnMV","select":"Menu_select__3xvEO"};